import React from 'react';
import SwiperView from './SwiperView';

import './Item.scss';

import { IProject } from './App';

interface ComponentProps {
  data: IProject;
}

const Item: React.FC<ComponentProps> = props => {
  const data = props.data;

  return (
    <div className={'item-container'}>
      <div className={'item-title-container'}>
        <div className={'item-title-dot'} />
        <p className={'item-title'}>{data.title}</p>
        {/* <img className={'item-title-image'} alt={'Logo'} /> */}
      </div>

      {data.screenshotList && (
        <SwiperView type={data.screenshotListType} list={data.screenshotList} />
      )}

      {data.screenshotList2 && (
        <SwiperView
          type={data.screenshotListType2}
          list={data.screenshotList2}
        />
      )}

      <div className={'item-desc-container'}>
        <p className={'item-desc-title'}>{data.descTitle}</p>
        <p className={'item-desc'}>
          {data.descList.map((descItem, descIndex) => {
            return (
              <>
                {descItem}
                <br />
              </>
            );
          })}
        </p>

        {data.url && (
          <p className={'item-desc'}>
            {'- Service Url'}
            <br />
            <a className={'item-link'} href={data.url} target={'_blank'}>
              {data.url}
            </a>
          </p>
        )}

        {data.playStoreUrl && (
          <p className={'item-desc'}>
            {'- Google Play Store'}
            <br />
            <a
              className={'item-link'}
              href={data.playStoreUrl}
              target={'_blank'}>
              {data.playStoreUrl}
            </a>
          </p>
        )}

        {data.appStoreUrl && (
          <p className={'item-desc'}>
            {'- AppStore'}
            <br />
            <a
              className={'item-link'}
              href={data.appStoreUrl}
              target={'_blank'}>
              {data.appStoreUrl}
            </a>
          </p>
        )}
      </div>
    </div>
  );
};

export default Item;
